module.exports = __webpack_public_path__ + "Icon_Do your part@2x.png?a0d5e4b9536289b3c35c4c89fad8bc0d";